import * as types from './mutation-types'
import Vue from 'vue'
import axios from 'axios';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

axios.defaults.withCredentials = false

export const setEmailItem = ({ commit }, data) => {
  commit(types.SET_EMAIL_ITEM, data)
}
export const changedrawer = ({ commit }, data) => {
    commit(types.CHANGEDRAWER, data)
  }

export const setMenu = ({ commit }, data) => {
  commit(types.SET_MENU, data)
}
export const setgroupBranch = ({ commit }, data) => {
  commit(types.SET_GROUP_BRANCH, data)
}

export const setGroupServiceh = ({ commit }, data) => {
  commit(types.SET_GROUP_SERVICE, data)
}
export const setSftpConfirmPayload = ({ commit }, data) => {
  commit(types.SET_SFTP_PAYLOAD, data)
}

export const setSftpConfirmPage = ({ commit }, data) => {
  commit(types.SET_SFTP_PAGE, data)
}

export const setSftpConfirmSelect = ({ commit }, data) => {
  commit(types.SET_SFTP_SELECT, data)
}

export const AUTH_PORTAL_SUCCESS = ({ commit }, data) => {
  commit(types.AUTH_PORTAL_SUCCESS, data)
}

export const AUTH_PORTAL_EXPIRED = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.AUTH_PORTAL_EXPIRED, data)
  })
}

export const ACCOUNT_PORTAL_SUCCESS = ({ commit }, data) => {
  // console.log("auth",data)
  commit(types.ACCOUNT_PORTAL_SUCCESS, data)
}

export const ACCOUNT_PORTAL_NOTFOUND = ({ commit }, data) => {
  commit(types.ACCOUNT_PORTAL_NOTFOUND, data)
}

export const AUTH_PORTAL_CHECK = ({ commit, dispatch },) => {
  return new Promise((resolve, reject) => {
    // if(localStorage.getItem("Access") != null){
    if(Vue.$cookies.isKey("Access") === true){
      // commit(types.AUTH_PORTAL_CHECK, JSON.parse(localStorage.getItem("Access"))['data']['refreshtoken'])
      // axios.post(process.env.API_GETBUSINESS + '/api/getaccusr_getbusiness', { 'token': JSON.parse(localStorage.getItem("Access"))['data']['refreshtoken']}, {withCredentials: false})
      commit(types.AUTH_PORTAL_CHECK, Vue.$cookies.get("Access")['data']['refreshtoken'])
      axios.post(process.env.API_GETBUSINESS + '/api/getaccusr_getbusiness', { 'token': Vue.$cookies.get("Access")['data']['refreshtoken']}, {withCredentials: false})
      .then((response) => {
        if(response.data.status === 'success'){
          commit(types.AUTH_PORTAL_SUCCESS, response.data)
          dispatch(types.ACCOUNT_PORTAL_CHECK, response.data).then(res=>{
            resolve(response.data)
          })
        }else{
          commit(types.AUTH_PORTAL_EXPIRED)
          resolve(response.data)
          Vue.$cookies.remove("Access")
          Vue.$cookies.remove("Username")
          Vue.$cookies.remove("STID")
          Vue.$cookies.remove("refreshtoken_package")
          localStorage.removeItem("Access");
          localStorage.removeItem("Username");
          localStorage.removeItem("STID");
          localStorage.removeItem("refreshtoken_package");
        }
      })
    } else {
      commit(types.AUTH_PORTAL_CHECK, '')
      commit(types.AUTH_PORTAL_EXPIRED)
      resolve({'result': 'fail'})
      Vue.$cookies.remove("Access")
      Vue.$cookies.remove("Username")
      Vue.$cookies.remove("STID")
      Vue.$cookies.remove("refreshtoken_package")
      localStorage.removeItem("Access");
      localStorage.removeItem("Username");
      localStorage.removeItem("STID");
      localStorage.removeItem("refreshtoken_package");
    }
  })

}

export const ACCOUNT_PORTAL_CHECK = ({ commit, dispatch }, data) => {
    commit(types.ACCOUNT_PORTAL_CHECK)
    return new Promise((resolve, reject) => {
      // axios.post(process.env.API_GETBUSINESS + '/api/usr_getbusiness', { "refreshToken": JSON.parse(localStorage.getItem("Access"))['data']['refreshtoken'], "accessToken": data.accesstoken }, {withCredentials: false})
      axios.post(process.env.API_GETBUSINESS + '/api/usr_getbusiness', { "refreshToken": Vue.$cookies.get("Access")['data']['refreshtoken'], "accessToken": data.accesstoken })
      .then((response) => {
        if (response.data.result === 'Success') {
          commit(types.ACCOUNT_PORTAL_SUCCESS, response.data.data[0])
        } else {
          dispatch(types.ACCOUNT_PORTAL_NOTFOUND, response.data)
          commit(types.AUTH_PORTAL_EXPIRED)
        }
        resolve(response.data)
      }).catch((error) => {
        console.log(error)
        resolve({'result': 'Fail'})
        commit(types.AUTH_PORTAL_EXPIRED)
      })
    })
  }

  export const CENTRESSO_PORTAL_REQUEST = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(types.CENTRESSO_PORTAL_REQUEST, 'checking').then(
      dispatch(types.CENTRESSO_PORTAL_SUCCESS)
      )

    })
  }

  // export const ACCOUNTPAYMENT_PORTAL_REQUEST = ({ commit, dispatch }, data) => {
  //   return new Promise((resolve, reject) => {
  //     commit(types.ACCOUNTPAYMENT_PORTAL_REQUEST, false)
  //     axios.post(process.env.API_PACKAGES, {"username": data.username ,"password": data.pass, "taxid": data.taxid}, { withCredentials: false })
  //     .then((response) => {
  //       console.log(response.data)
  //       if(response.data.result === 'Success'){
  //         localStorage.setItem("refreshtoken_package", response.data.data['refreshtoken'])
  //         dispatch(types.ACCOUNTPAYMENT_PORTAL_SUCCESS, response.data.data['refreshtoken'])
  //       }
  //       else{
  //         dispatch(types.ACCOUNTPAYMENT_PORTAL_NOTFOUND, false)
  //       }
  //     })
  //   })
  // }

  // export const ACCOUNTPAYMENT_PORTAL_SUCCESS = ({ commit }, data) => {
  //   commit(types.ACCOUNTPAYMENT_PORTAL_SUCCESS, data)
  // }

  // export const ACCOUNTPAYMENT_PORTAL_CHECK = ({ commit, dispatch }, data) => {
  //   return new Promise((resolve, reject) => {
  //     commit(types.ACCOUNTPAYMENT_PORTAL_CHECK, false)
  //     if (localStorage.getItem("refreshtoken_package") !== null) {
  //       dispatch(types.ACCOUNTPAYMENT_PORTAL_SUCCESS, localStorage.getItem("refreshtoken_package"))
  //     }
  //     else {
  //       dispatch(types.ACCOUNTPAYMENT_PORTAL_NOTFOUND, false)
  //     }
  //   })
  // }

  // export const ACCOUNTPAYMENT_PORTAL_NOTFOUND = ({ commit }, data) => {
  //   commit(types.ACCOUNTPAYMENT_PORTAL_NOTFOUND, data)
  // }







// WEBPACK FOOTER //
// ./src/store/action.js